import React, {useEffect} from 'react';
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {FormattedMessage} from "react-intl";

import Styled from './styled';
import {getMarriageNOCSelector} from "services/marriageNoc/marriageNoc.selector";
import StyledContainer from "components/styled/StyledContainer";
import MarriageNocDetailsStatus from "./MarriageNocDetails.Status/MarriageNocDetails.Status";
import MarriageNocDetailsForm from "containers/MarriageNOCDetails/MarriageNOCDetails.Form";
import {replaceFilesAction} from "services/file/file.action";
import {findRelatedNOC} from "services/marriageNoc/marriageNoc.actions";
import {FILES_TYPE, FORMS_NAMES, LOADERS} from "constants/constants";
import isArray from "redux-actions/lib/utils/isArray";
import OtherNOCsModal from "containers/MarriageNOCDetails/MarriageNocDetails.Others/MarriageNocDetails.Others";
import NocWarningModal from "containers/MarriageNOCDetails/MarriageNocDetails.Warning";
import {getLoaderByName} from "@/services/loader/loader.selector";
import Loader from "@/components/Loader/Loader";

const MarriageNocDetails = () => {
  const {uuid} = useParams()
  const marriageNOC = useSelector(state => getMarriageNOCSelector(state, uuid));
  const dispatch = useDispatch();
  const isLoading = useSelector(state => getLoaderByName(state, LOADERS.MARRIAGE_NOC));

  console.log('MarriageNOC Details:', {
    marriageNOC,
    isLoading,
  });

  const setFiles = (fieldName) => {
    const files = isArray(marriageNOC?.[fieldName]) ? marriageNOC?.[fieldName] : [marriageNOC?.[fieldName]]
    dispatch(replaceFilesAction({
      files: files || [],
      formName: "marriageNOC",
      name: fieldName
    }));
  }

  useEffect(() => {
    if (marriageNOC?.id) {
      setFiles(FILES_TYPE.MARRIAGE_NOC_PHOTO);
      setFiles(FILES_TYPE.MARRIAGE_NOC_HARD_COPY);
      setFiles(FILES_TYPE.MARRIAGE_NOC_CANCELLATION_PROOF);
      setFiles(FILES_TYPE.MARRIAGE_NOC_DOCUMENTS);
    }
  }, [marriageNOC?.id])

  useEffect(() => {
    dispatch(findRelatedNOC({uuid}))
  }, [marriageNOC?.id])

  return (
    <Styled.Page>
      <StyledContainer>
        <Styled.Title>
          <FormattedMessage id={"MarriageNOCDetails.Title"}/>
        </Styled.Title>
        <Loader name={LOADERS.MARRIAGE_NOC}>
          {marriageNOC && !isLoading && (
            <>
              <MarriageNocDetailsStatus marriageNOC={marriageNOC}/>
              <MarriageNocDetailsForm
                marriageNOC={marriageNOC}
                initialValues={{
                  ...marriageNOC,
                  church: marriageNOC?.church?.id,
                }}
              />
            </>
          )}
        </Loader>
      </StyledContainer>
      <OtherNOCsModal marriageNOC={marriageNOC}/>
      <NocWarningModal marriageNOC={marriageNOC}/>
    </Styled.Page>
  );
};

export default MarriageNocDetails;
